import { render, staticRenderFns } from "./EWUserLimitConfigLogList.vue?vue&type=template&id=1c318d37&"
import script from "./EWUserLimitConfigLogList.vue?vue&type=script&lang=js&"
export * from "./EWUserLimitConfigLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports